// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/crfi-expected-by-surface.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/crfi-expected-by-surface/crfi-expected-by-surface.js';

mount([g0]);
